<template>
  <div class="flex justify-left ml-12 relative">
    <div class="flex flex-col mt-3 items-left justify-center pr-2">
      <label for="param-name">Param Name</label>
      <input
        :id="`${indexNo}-param-name`"
        ref="paramName"
        :value="param.name"
        class="p-3 border"
        placeholder="Enter param name"
        required
        type="text"
        style="margin:0"
        @input="
          $emit('UPDATE_PARAM_NAME', {
            idx: indexNo,
            value: $event.target.value,
            paramName: 'name',
          })
        "
      />
    </div>
    <div class="flex flex-col mt-3 items-left justify-center relative">
      <label for="dashboard-name">Param Type</label>
      <VueSelect
        class="pr-3 w-full type-selector"
        :options="allTypes"
        :value="param.type"
        @input="handleSelectInput"
      />
    </div>
    <div
      v-if="param.value !== undefined"
      class="flex flex-col mt-3 items-left justify-center relative"
    >
      <label for="dashboard-name">Param Value</label>
      <input
        :id="`${indexNo}-param-value`"
        :value="param.value"
        class="p-3 border"
        placeholder="Enter param value"
        required
        type="text"
        style="margin:0"
        @input="handleValueInput('value', $event)"
      />
    </div>
    <div
      v-if="param.range !== undefined"
      class="flex flex-col mt-3 items-left justify-center relative"
    >
      <label for="dashboard-name">Param Range</label>
      <input
        :id="`${indexNo}-param-range`"
        :value="param.range"
        class="p-3 border"
        placeholder="Enter param range"
        required
        type="text"
        style="margin:0"
        @input="handleValueInput('range', $event)"
      />
    </div>
    <button
      title="Delete this param"
      class="remove-icon"
      @click.prevent="removeParam"
    >
      &times;
    </button>
  </div>
</template>

<script>
import VueSelect from "vue-select"

export default {
  components: {
    VueSelect,
  },
  props: {
    param: {
      type: Object,
      default() {
        return {}
      },
      required: true,
    },
    indexNo: {
      type: Number,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      allTypes: ["text", "date", "email", "random"],
    }
  },
  mounted() {
    // only focus on new addition, not on initial load
    if (this.param.name === "") {
      this.$refs.paramName.focus()
    }
  },
  methods: {
    removeParam() {
      this.$emit("REMOVE_PARAM", this.indexNo)
    },
    handleSelectInput(value) {
      this.$emit("UPDATE_PARAM_NAME", {
        idx: this.indexNo,
        value,
        paramName: "type",
      })
    },
    handleValueInput(paramName, $event) {
      this.$emit("UPDATE_PARAM_NAME", {
        idx: this.indexNo,
        value: $event.target.value,
        paramName,
      })
    },
  },
}
</script>

<style scoped>
.type-selector {
  min-width: 12rem;
}

.remove-icon {
  position: absolute;
  bottom: 0px;
  left: -2rem;
  padding: 0;
  border-radius: 0;
  color: red;
  font-size: 2rem;
  line-height: 0.5;
  transform: translateY(-50%);
}

.remove-icon:hover {
  background: #e7e7e7;
}
</style>
